<template>
    <div class="commission my-3">
        <b-row>
            <b-col cols="12">
                <el-checkbox v-model="form.epf_excluded" class="mb-4">Exclude EPF</el-checkbox>
            </b-col>
            <b-form>
                <b-col cols="12">
                    <b-form-group label="Sales Commission / Incentives / Part Time Job / Pension">
                        <b-row>
                            <b-col md="4" cols="12"
                            class="d-flex align-items-center my-2"
                            v-for="(commision, index) in commissions" :key="index">
                                <CurrencyInput
                                    v-model="commision.amount"
                                    :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                    :inputPlaceholder="`Month ${index + 1}`"
                                />
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-button-group class="w-100">
                        <b-button @click="addMonths" :disabled="commissions.length >= 12" variant="outline-primary" class="mt-3">+ Add</b-button>
                        <b-button @click="removeMonths" :disabled="commissions.length <= 0" variant="outline-danger" class="mt-3">- Remove</b-button>
                    </b-button-group>
    
                </b-col>
                <!-- <b-col cols="4" class="mt-3">
                    <b-button block variant="primary" type="submit">Save</b-button>
                </b-col> -->
            </b-form>
        </b-row>
    </div>
</template>
<script>
    import { Button,  Checkbox } from 'element-ui'
    import { mapActions } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
    import CurrencyInput from '@/components/CurrencyInput'

    export default {
        props: ['customer'],
        components: {
            CurrencyInput,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
        },
        computed:{
            commissions(){
							return _gHlp.getValue(this.customer,'incomes.commission',[]);
            }
        },
        data() {
            return {
                form: {
                    epf_excluded: this.customer.incomes.main.is_ex_epf_com ?? false
                }
            }
        },
        created(){
					gEventBus.$on('collect-income-data', this.sendIncomeData);
        },
        beforeDestroy() {
					gEventBus.$off('collect-income-data', this.sendIncomeData);
        },
        methods: {
            ...mapActions(useCustomerStore, ['getCustomer']),
            setData(){
                let commissions = _gHlp.isEmpty(this.commissions) ? [] : this.commissions.map(obj => {
                    return {
                        ...(obj.customer_commision_income_id && { customer_commision_income_id: obj.customer_commision_income_id }),
                        amount:obj.amount
                    }
                })

                let data = {
                    commissions:commissions,
                    is_ex_epf_com: this.form.epf_excluded,
                }

                return data;
            },
            addMonths() {
                if (this.commissions.length < 12) {
                    this.commissions.push({amount: null});
                }
            },
            removeMonths() {
                if (this.commissions.length > 0) {
                    this.commissions.pop();
                }
            },
            sendIncomeData(){
                this.$emit('income-data-collected', this.setData());
            }
        }
    }
</script>